import { LoaderFunction, redirect } from "react-router-dom";
import HttpService from "@core/services/http/http.service";
import StorageService from "@core/services/storage";
import { Role, RoutePath, USER_INFO_KEY } from "@app/constants";
import { UserData } from "@app/types";

export const isAuthenticated: LoaderFunction = ({ request }) => {
  const token = HttpService.getAccessToken();
  const userInfo = StorageService.getObject(USER_INFO_KEY) as UserData;

  if (!token && !request.url.includes(RoutePath.SIGN_IN)) {
    return redirect(RoutePath.SIGN_IN);
  }

  if (token && request.url.includes(RoutePath.SIGN_IN)) {
    if (userInfo?.role === Role.ADMIN || userInfo?.role === Role.ROOT) {
      return redirect(`/${RoutePath.BOOK_MANAGEMENT}`);
    }

    return redirect(RoutePath.HOME);
  } else if (token && userInfo?.role === Role.USER) {
    return true;
  }

  return true;
};
